import React, { useState } from 'react';
import { Typography, Button, Modal, Row as GridRow, Col } from 'design-system';

const Separator = ({ className = '' }) => (
  <div className={['separator', className].filter(Boolean).join(' ')} />
);

export default function ModalShowcase() {
  const [modalModuleSingleOpen, setModalModuleSingleOpen] = useState(false);
  const [modalModuleDualOpen, setModalModuleDualOpen] = useState(false);
  const [modalDialogOpen, setModalDialogOpen] = useState(false);
  const [modalDialogSuccessNoCloseOpen, setModalDialogSuccessNoCloseOpen] = useState(false);
  const [modalDialogDangerOpen, setModalDialogDangerOpen] = useState(false);
  const [modalDialogDangerNoCloseOpen, setModalDialogDangerNoCloseOpen] = useState(false);

  return (
    <>
        {/* Modal */}
        <GridRow>
          <Col xs={12}>
            <div className="design-system-section">
              <Typography variant="h1" className="section-title mb-4">
                Modal
              </Typography>
              <Separator className="mb-5" />
              <div className="d-flex flex-wrap" style={{ gap: 12 }}>
                <Button variant="secondary" size="sm" onClick={() => setModalModuleSingleOpen(true)}>
                  Module · one action
                </Button>
                <Button variant="secondary" size="sm" onClick={() => setModalModuleDualOpen(true)}>
                  Module · two actions
                </Button>
                <Button variant="secondary" size="sm" onClick={() => setModalDialogOpen(true)}>
                  Dialog · success
                </Button>
                <Button variant="secondary" size="sm" onClick={() => setModalDialogSuccessNoCloseOpen(true)}>
                  Dialog · success without close
                </Button>
                <Button variant="secondary" size="sm" onClick={() => setModalDialogDangerOpen(true)}>
                  Dialog · danger
                </Button>
                <Button variant="secondary" size="sm" onClick={() => setModalDialogDangerNoCloseOpen(true)}>
                  Dialog · danger without close
                </Button>
              </div>
              <Modal
                open={modalModuleSingleOpen}
                variant="module"
                type="success"
                title="Payment successful"
                description="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt."
                primaryText="Go back to dashboard"
                primaryButtonTone="secondary"
                onPrimary={() => setModalModuleSingleOpen(false)}
                onDismiss={() => setModalModuleSingleOpen(false)}
              />
              <Modal
                open={modalModuleDualOpen}
                variant="module"
                type="success"
                title="Payment successful"
                description="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquid pariatur, ipsum similique veniam."
                primaryText="Yes, Proceed"
                secondaryText="Cancel"
                onPrimary={() => setModalModuleDualOpen(false)}
                onDismiss={() => setModalModuleDualOpen(false)}
              />
              <Modal
                open={modalDialogOpen}
                variant="dialog"
                type="success"
                showClose
                title="Activate account"
                description="Are you sure you want to deactivate your account? All of your data will be permanently removed from our servers forever. This action cannot be undone."
                primaryText="Yes, Activate"
                secondaryText="Cancel"
                onPrimary={() => setModalDialogOpen(false)}
                onDismiss={() => setModalDialogOpen(false)}
              />
              <Modal
                open={modalDialogSuccessNoCloseOpen}
                variant="dialog"
                type="success"
                title="Activate account"
                description="Are you sure you want to deactivate your account? All of your data will be permanently removed from our servers forever. This action cannot be undone."
                primaryText="Yes, Activate"
                secondaryText="Cancel"
                onPrimary={() => setModalDialogSuccessNoCloseOpen(false)}
                onDismiss={() => setModalDialogSuccessNoCloseOpen(false)}
              />
              <Modal
                open={modalDialogDangerNoCloseOpen}
                variant="dialog"
                type="danger"
                title="Deactivate account"
                description="Are you sure you want to deactivate your account? All of your data will be permanently removed from our servers forever. This action cannot be undone."
                primaryText="Yes, Deactivate"
                secondaryText="Cancel"
                onPrimary={() => setModalDialogDangerNoCloseOpen(false)}
                onDismiss={() => setModalDialogDangerNoCloseOpen(false)}
              />
              <Modal
                open={modalDialogDangerOpen}
                variant="dialog"
                type="danger"
                showClose
                title="Deactivate account"
                description="Are you sure you want to deactivate your account? All of your data will be permanently removed from our servers forever. This action cannot be undone."
                primaryText="Yes, Deactivate"
                secondaryText="Cancel"
                onPrimary={() => setModalDialogDangerOpen(false)}
                onDismiss={() => setModalDialogDangerOpen(false)}
              />
            </div>
          </Col>
        </GridRow>
    </>
  );
}